module.exports = __webpack_public_path__ + "img/senderrrand-runners-banner.420e6724.svg";